import { render, staticRenderFns } from "./SkillsMe.vue?vue&type=template&id=d2c03624&scoped=true&"
import script from "./SkillsMe.vue?vue&type=script&lang=js&"
export * from "./SkillsMe.vue?vue&type=script&lang=js&"
import style0 from "./SkillsMe.vue?vue&type=style&index=0&id=d2c03624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c03624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDialog,VIcon,VImg,VRow})
